import { kioskLocation } from "../App/kioskRoutes";
import { ModalCloseButton } from "./LucidePrimitives";
import {
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import { useKiosk } from "../Contexts/KioskContext";

export default function SwipeOrReservePopup({ isOpen, onClose, onCheckOut }) {
  const history = useHistory();
  const { isKiosk } = useKiosk();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      aria-labelledby="swipe-reserve-header"
      aria-describedby="swipe-reserve-body"
    >
      <ModalOverlay />
      <ModalContent rounded="lg" p={isKiosk ? 8 : undefined}>
        <ModalHeader
          id="swipe-reserve-header"
          color="gray.800"
          fontSize={isKiosk ? "2xl" : undefined}
          fontWeight={700}
        >
          Hey there!
        </ModalHeader>
        <ModalCloseButton
          aria-label="Close dialog"
          {...(isKiosk && { size: "lg", p: 4 })}
        />
        <ModalBody id="swipe-reserve-body">
          <Text color="gray.600" fontSize={isKiosk ? "xl" : undefined}>
            It looks like you already have an active session in this space.
            Would you like to check out or update your tool usage?
          </Text>
        </ModalBody>
        <ModalFooter
          flexDirection={isKiosk ? "column" : "row"}
          gap={isKiosk ? 3 : undefined}
        >
          <Button
            variant="outline"
            {...(!isKiosk && { mr: 3 })}
            {...(isKiosk && { size: "kiosk", w: "full", borderWidth: "2px" })}
            onClick={async () => {
              const ok = await onCheckOut();
              if (ok !== false) {
                history.push(kioskLocation("/kiosk/check-out/complete", history.location));
                onClose();
              }
            }}
          >
            Check out
          </Button>
          <Button
            {...(isKiosk && { size: "kiosk", w: "full" })}
            onClick={() => {
              history.push(kioskLocation("/kiosk/check-in/tools", history.location), { toolUsageFlow: "update" });
              onClose();
            }}
          >
            Update tool usage
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
